/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [{
    _id: "EW4pNzAbVao",
    title: "Bombay Dreams ",
    description: "EDM Music , video shows story of a younge boy",
    creator: "Lost Stories & KSHMR",
    category: " EDM",
    duration: "03:29",
    views: "34.7M",
  uploaded: "2",
    creatorImage: "https://yt3.ggpht.com/RHFXcMPoZg4NjA7XGYG-GwOLYmrQUvsf1WjxRULvjnwknfcKb9TAmneEnVTHXKncLWBiI2Edqys=s88-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "WaCj4ypsjXA",
    title: " Good for you ",
    description: "Krewella roaming in India",
    creator: "Nucleya & Krewella",
    category: " EDM",
    duration: "04:19",
    views: "43.5M",
    uploaded: "4",
    creatorImage: "https://yt3.ggpht.com/WW0xXNOpEbUMdVfzyHD2hbZSolzqPtappvqMC2TKSyfxxIMOTU2YDc9Y11gn9qldvhG8Tp2BYA=s176-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "lgT1AidzRWM",
    title: "Eminem - Beautiful",
    description: "Eminem telling his story",
    creator: "Eminem",
    category: " English rap",
    duration: "05:20",
    views: "443.5M",
    uploaded: "12",
    creatorImage: "https://yt3.ggpht.com/ytc/AKedOLTl3oEyE5erZSJL6T3AqzFUo2pjsbI2f595a8gvQQ=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "_Yhyp-_hX2s",
    title: " Eminem - Lose Yourself ",
    description: "Eminem motivational song , explaining not to give up",
    creator: "Eminem",
    category: " English rap",
    duration: "06:26",
    views: "773.5M",
    uploaded: "1",
    creatorImage: "https://yt3.ggpht.com/ytc/AKedOLTl3oEyE5erZSJL6T3AqzFUo2pjsbI2f595a8gvQQ=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "rO4DbBjaWJY",
    title: "Divine - Satya ",
    description: "Gully gang song",
    creator: "Divine",
    category: "Desi Hip Hop",
    duration: "04:19",
    views: "43.5M",
    uploaded: "4",
    creatorImage: "https://yt3.ggpht.com/ytc/AKedOLRkGpz9MfdI1raQhLZrozgnIyuh8v0xffgptq3HHQ=s88-c-k-c0x00ffffff-no-rj"
  },
   {
     _id: "xQsHpqDTL-o",
     title: "AFKAP - AAINA ",
     description: "Awesome song",
     creator: "AFKAP",
     category: "Desi Hip Hop",
     duration: "02:29",
     views: "4.5M",
     uploaded: "9",
     creatorImage: "https://yt3.ggpht.com/ytc/AKedOLQBoBlDevqIuBxrZ82gj_HgCjA_CVJ8yHw-3bRGRw=s68-c-k-c0x00ffffff-no-rj"
  },
   {
     _id: "aSeKe_9qgqU",
     title: "Fotty Seven - Banjo",
     description: "Delhi rap scene",
     creator: "Fotty Seven",
     category: "Desi Hip Hop",
     duration: "04:29",
     views: "36.5M",
     uploaded: "14",
     creatorImage: "https://yt3.ggpht.com/ytc/AKedOLSneJovSl_Adtpf5odnE6Hr2f9YLa0J13kffCz9Sg=s176-c-k-c0x00ffffff-no-rj"
  },
    {
      _id: "kXYiU_JCYtU",
      title: "Linkin Park - Numb ",
      description: "Best song ever",
      creator: "Linkin Park",
      category: "English Rock",
      duration: "04:49",
      views: "2B",
      uploaded: "4",
      creatorImage: "https://yt3.ggpht.com/ytc/AKedOLTP3cbFb1DZb6KospraOxmO3xSGdl5la19iQi0ynZQ=s88-c-k-c0x00ffffff-no-rj"
  },
     {
       _id: "5qF_qbaWt3Q",
       title: " Waiting for the End ",
       description: " Evergreen song",
       creator: "Linkin Park",
       category: "English Rock",
       duration: "03:02",
       views: "998M",
       uploaded: "4",
       creatorImage: "https://yt3.ggpht.com/ytc/AKedOLTP3cbFb1DZb6KospraOxmO3xSGdl5la19iQi0ynZQ=s88-c-k-c0x00ffffff-no-rj"
  },
      {
        _id: "r00ikilDxW4",
        title: "Green Day - 21 Guns ",
        description: "Good song",
        creator: "Green Day",
        category: "English Rock",
        duration: "3:34",
        views: "755M",
        uploaded: "4",
        creatorImage: "https://yt3.ggpht.com/ytc/AKedOLTOKrgEssJwbh9M7G0w1lngpWgzcfiEBOeT584wOQ=s88-c-k-c0x00ffffff-no-rj"
      },
];